








import {
  Vue,
  Component,
  Prop,
  Mixins
} from 'vue-property-decorator';
import { 
  Parkinglot,
  AllianceParkinglot
} from '@/models/parkinglot.model';

import {
  Action
} from 'vuex-class';

import StorageService from '@/mixins/StorageService';
import { api } from '@/models/api-path.model';

@Component({
  components: {}
})
export default class ImageUpload extends Mixins(
  StorageService
) {
  @Action('showAlert', { namespace: 'dialog' }) showAlert!: any;

  $refs!: {
    inputHidden: HTMLFormElement;
    canvas: HTMLCanvasElement
  };

  @Prop()
  parkinglot!: Parkinglot;

  @Prop()
  groupNum!: string;

  @Prop()
  maxLength!: number;

  level!: string;

  constructor() {
    super();
    this.level = this.getStorage('local', 'level');
  }

  private beforeCreate(): void {}
  private created(): void {}
  private beforeMount(): void {}
  private mounted(): void {}
  private beforeUpdate(): void {}
  private updated(): void {}
  private destroyed(): void {}

  openImageUpload(): void {
    if (this.parkinglot.parkinglot_type === 1) {
      return;
    }
    this.$refs.inputHidden.onchange = (event) => {
      //this.uploadContractFileChange(event, type);
      this.activeImageUpload(event);
    };
    this.$refs.inputHidden.click();
    
  }

  activeImageUpload(event: any) {
    if (this.parkinglot.attachment[String(this.groupNum)].length >= this.maxLength) {
        this.showAlert({
          message: '파일 업로드 허용 갯수를 넘었습니다.'
        });
        return;
    }

    const file: File = event.target.files[0];

    if (!file) {
        return;
    }

    if (!file.type.match(/image.*/)) {
        alert('이미지 파일만 업로드가 가능합니다.'); // 이미지 파일이 아닌 파일이 전송되면 error
        return;
    }

    // promise 반환
    this.resizeImage({
      file,
      maxSize: 600
    }).then((resizedImage: Blob) => {
      const formData: FormData = new FormData();
      formData.append('parkinglot_type', String(this.parkinglot.parkinglot_type));
      formData.append('group_num', String(this.groupNum));
      formData.append('file', resizedImage, file.name);

      if (this.parkinglot.idx) {
        formData.append('idx', String(this.parkinglot.idx));
      }

      this.imageUploadHandler(formData);
    });
  }

  imageUploadHandler(payload: FormData) {
    this.$http.post(api.parkinglotFileUpload, payload).then(
      (resp: any) => {
        this.$refs.inputHidden.value = '';
        const { code, data, message, error } = resp.data;

        if (error) {
          this.showAlert({
            message: error
          })
          return;
        }

        if (code !== 20000) {
          this.showAlert({
            message: message
          })
          return;
        }

        this.$emit('upload', { group: String(this.groupNum), file: data });
      }
    );
  }

  resizeImage(settings: any): Promise<any> {
    // 와이드 맥스,height 맥스
    const { file, maxSize } = settings;

    const reader = new FileReader();
    const image = new Image(); // 이미지 엘리먼트 생성
    const isNoResize = ['8000', '8001', '8002', '8003'].some(v => v === this.groupNum);

    // 리사이즈 된 canvas데이터(string형태) 받아서 Blob객체 인스턴스로 반환
    const dataURItoBlob = (dataURI: string) => {
      const bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
        atob(dataURI.split(',')[1]) :
        encodeURI(dataURI.split(',')[1]);
      const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const max = bytes.length;
      const ia = new Uint8Array(max);
      for (let i = 0; i < max; i++) { ia[i] = bytes.charCodeAt(i); }
      return new Blob([ia], { type: mime });
    };

    // canvas 이용한 resize 수행 후 결과물을 dataURItoBlob에 전달하면서 호출
    const resize = () => {
      let imageWidth = image.width;
      let imageHeight = image.height;

      if (imageWidth > imageHeight) {
        imageWidth = 1920;
        imageHeight = 1080;
      } else {
        imageWidth = 1080;
        imageHeight = 1920;
      }

      const width = isNoResize ? imageWidth : 600;
      const height = isNoResize ? imageHeight : 450;

      if (this.$refs.canvas) {
        this.$refs.canvas.width = width;
        this.$refs.canvas.height = height;
        this.$refs.canvas.getContext('2d')?.drawImage(image, 0, 0, width, height);
      }
      
      const dataUrl = this.$refs.canvas.toDataURL('image/jpeg');
      return dataURItoBlob(dataUrl);
    };

    return new Promise((ok, no) => {
      // 파일이 로딩되었을때
      reader.onload = (readerEvent: any) => { // 읽기 동작이 성공적으로 완료 되었을 때(1-2)
        image.onload = () => ok(resize()); // 읽기 성공 시 resize() 수행 (2-2)
        image.src = readerEvent.target.result; // src설정 (2-1)
      };
      reader.readAsDataURL(file); // 전달된 file을 읽는다 (1-1)
    });
  }
}

